import ToLoginPageRedirection from './ToLoginPageRedirection';

export default ToLoginPageRedirection;
